export default __webpack_public_path__ + "static/media/ban-blue-xl.33f3bf8d.svg";